import { render, staticRenderFns } from "./Die_Materials.vue?vue&type=template&id=e4f0b1bc&scoped=true"
import script from "./Die_Materials.vue?vue&type=script&lang=js"
export * from "./Die_Materials.vue?vue&type=script&lang=js"
import style0 from "./Die_Materials.vue?vue&type=style&index=0&id=e4f0b1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f0b1bc",
  null
  
)

export default component.exports